import {
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    Typography,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { useGet } from "../hooks/api-call";

const GstTypeSelector = ({
    control,
    setValue,
    watch,
    errors,
    // gstPercentages = [],
    labelPrefix = "material", // like: "material", "freight", etc.
}) => {
    const { responseData: gstPercentages } = useGet(`getAllGstPercentage`);

    const taxTypeField = `gst${labelPrefix?.charAt(0).toUpperCase() + labelPrefix?.slice(1)}Type`;
    const igstField = `${labelPrefix}IgstPrcntId`;
    const sgstField = `${labelPrefix}SgstPrcntId`;
    const cgstField = `${labelPrefix}CgstPrcntId`;

    const taxType = watch(taxTypeField);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <Controller
                    name={taxTypeField}
                    control={control}
                    defaultValue="IGST"
                    render={({ field }) => (
                        <FormControl component="fieldset" fullWidth>
                            <FormLabel>{labelPrefix?.charAt(0).toUpperCase() + labelPrefix?.slice(1)} Tax</FormLabel>
                            <RadioGroup
                                row
                                {...field}
                                onChange={(e) => {
                                    field.onChange(e);
                                    // Clear only current section
                                    setValue(igstField, null);
                                    setValue(sgstField, null);
                                    setValue(cgstField, null);
                                }}
                            >
                                <FormControlLabel value="IGST" control={<Radio />} label="IGST" />
                                <FormControlLabel value="CGST_SGST" control={<Radio />} label="SGST & CGST" />
                            </RadioGroup>
                        </FormControl>
                    )}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                {taxType === "IGST" ? (
                    <FormControl fullWidth error={!!errors?.[igstField]}>
                        <InputLabel id={`${igstField}-label`}>IGST</InputLabel>
                        <Controller
                            name={igstField}
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <Select labelId={`${igstField}-label`} label="IGST" {...field}>
                                    {(gstPercentages || [])
                                        .filter((option) => option.value !== 0)
                                        .map((option) => (
                                            <MenuItem key={option.gstPercentageId} value={option.gstPercentageId}>
                                                {option.value}
                                            </MenuItem>
                                        ))}
                                </Select>
                            )}
                        />
                    </FormControl>
                ) : (
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <FormControl fullWidth error={!!errors?.[sgstField]}>
                                <InputLabel id={`${sgstField}-label`} shrink={!!watch(sgstField)}>
                                    SGST
                                </InputLabel>
                                <Controller
                                    name={sgstField}
                                    control={control}
                                    render={({ field }) => (
                                        <Select
                                            labelId={`${sgstField}-label`}
                                            label="SGST"
                                            {...field}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue(cgstField, e.target.value);
                                            }}
                                        >
                                            {(gstPercentages || [])
                                                .filter((option) => option.value !== 0 && option.value !== 18)
                                                .map((option) => (
                                                    <MenuItem key={option.gstPercentageId} value={option.gstPercentageId}>
                                                        {option.value}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth error={!!errors?.[cgstField]}>
                                <InputLabel id={`${cgstField}-label`} shrink={!!watch(cgstField)}>
                                    CGST
                                </InputLabel>
                                <Controller
                                    name={cgstField}
                                    control={control}
                                    render={({ field }) => (
                                        <Select
                                            labelId={`${cgstField}-label`}
                                            label="CGST"
                                            {...field}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setValue(sgstField, e.target.value);
                                            }}
                                        >
                                            {(gstPercentages || [])
                                                .filter((option) => option.value !== 0 && option.value !== 18)
                                                .map((option) => (
                                                    <MenuItem key={option.gstPercentageId} value={option.gstPercentageId}>
                                                        {option.value}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                )}
            </Grid>

            {(errors?.[igstField] || errors?.[sgstField] || errors?.[cgstField]) && (
                <Grid item xs={12}>
                    <Typography color="error" variant="body2">
                        Please select valid GST values.
                    </Typography>
                </Grid>
            )}
        </Grid>
    );
};

export default GstTypeSelector;
